/*@ngInject*/
const CachedDataSetsRepository = function (baseCachedRepository) {

    angular.extend(this, baseCachedRepository);

    this.getCacheName = function () {
        return 'cachedDataSetsRepository';
    };

    this.getCacheCapacity = function () {
        return 50;
    };

    this.getDataSet = function (name) {
        let url = '/rest/DataSet',
            config = {
                params: {
                    dataSetName: name
                }
            },
            cacheKey = name;

        return this.get(cacheKey, url, config);
    };
};

angular.module('umCore')
    .service('cachedDataSetsRepository', CachedDataSetsRepository);
